import React from 'react'
import './Banner.css'
import Banner_ from '../../assests/slip-icon (4).png'
import Utility_Banner from '../../assests/Component 4.png'
import Dark_Banner from '../../assests/Frame 186399 (1).png'
import { Link } from 'react-router-dom'


const Banner = () => {
  return (
    <div className='banner-partners'>
      <div className="banner-partner-features">
        <div className='banner'>
            <img src={Banner_} alt="" />
        </div>
        <div className="banner">
            <img src={Utility_Banner} alt=""/>
        </div>
        <div className="banner">
            <Link to='/products' >
                <img src={Dark_Banner} alt="" />
            </Link>
        </div>
      </div>
    </div>
  )
}

export default Banner
